/* ==========================================================================
   CounterRxjs > Client > Buttons
   ========================================================================== */

/* Modules */
const { filter } = require('rxjs/operators');

const Button = require('../../../../button-rxjs/client/js');

const { actions, types } = require('../store/actions');

const { updateUI } = require('../ui');

const configuration = require('../config');

/* Init */
function initButtons(instance) {
    const panel = instance;

    /* Selector */
    const { selector } = instance;

    /* Increment */
    panel.increment = Button(
        `${selector} [data-component='ButtonRxjs'][data-type='${configuration().type.increment}']`
    );

    /* Decrement */
    panel.decrement = Button(
        `${selector} [data-component='ButtonRxjs'][data-type='${configuration().type.decrement}']`
    );

    /* Actions */
    panel.actions = {
        ...instance.actions,
        increment: () => instance.store.dispatch(actions.increment()),
        decrement: () => instance.store.dispatch(actions.decrement())
    };

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        increment: instance.store.subscribe((state, action) => {
            if (action.type !== types.INCREMENT) return;

            /* Data */
            const { value } = state.counter;

            /* Update UI */
            updateUI(value, instance);
        }),
        decrement: instance.store.subscribe((state, action) => {
            if (action.type !== types.DECREMENT) return;

            /* Data */
            const { value } = state.counter;

            /* Update UI */
            updateUI(value, instance);
        })
    };

    /* Subscriptions */
    panel.subscriptions = {
        ...instance.subscriptions,
        increment: instance.increment.events.click$
            .pipe(
                filter(() => {
                    /* Data */
                    const { disabled } = instance.store.select('counter');

                    if (disabled) {
                        return false;
                    }

                    return true;
                })
            )
            .subscribe(() => {
                /* Dispatch action */
                instance.actions.increment();
            }),
        decrement: instance.decrement.events.click$
            .pipe(
                filter(() => {
                    /* Data */
                    const { disabled } = instance.store.select('counter');

                    if (disabled) {
                        return false;
                    }

                    return true;
                })
            )
            .subscribe(() => {
                /* Dispatch action */
                instance.actions.decrement();
            })
    };

    return this;
}

/* Destroy */
function destroyButtons(instance) {
    const panel = instance;

    /* References */
    instance.increment.actions.destroy();
    delete panel.increment;

    instance.decrement.actions.destroy();
    delete panel.decrement;

    /* Actions */
    delete panel.actions.increment;
    delete panel.actions.decrement;

    /* Reactions */
    instance.reactions.increment.unsubscribe();
    delete panel.reactions.increment;

    instance.reactions.decrement.unsubscribe();
    delete panel.reactions.decrement;

    /* Subscriptions */
    instance.subscriptions.increment.unsubscribe();
    delete panel.subscriptions.increment;

    instance.subscriptions.decrement.unsubscribe();
    delete panel.subscriptions.decrement;
}

/* Exports */
module.exports = {
    initButtons,
    destroyButtons
};
